"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMatchedBreakpoints = exports.setUpQueries = exports.removeBreakpointCallback = exports.getQueryList = exports.getDocSiteBreakpoints = exports.debouncedCallBacks = exports.callCallbacks = exports.breakpointWatcher = exports.addBreakpointCallback = void 0;
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var baseBreakpoints = ['md', 'lg', 'xl'];
var sortedBreakpoints = ['xl', 'lg', 'md', 'sm']; // Tracks breakpoint matches, queries and callbacks

var breakpointWatcher = {
  breakpoints: {
    sm: false,
    md: false,
    lg: false,
    xl: false,
    mdAndBelow: false,
    mdAndAbove: false,
    lgAndBelow: false,
    lgAndAbove: false,
    current: 'sm'
  },
  queries: {},
  callbacks: []
}; // Used to initialise the breakpoint list

exports.breakpointWatcher = breakpointWatcher;
var getQueryList = function getQueryList(themeBreakpoints) {
  var md = themeBreakpoints.md,
    lg = themeBreakpoints.lg,
    xl = themeBreakpoints.xl;
  return {
    md: "(min-width: ".concat(md, "px) and (max-width: ").concat(lg - 1, "px)"),
    lg: "(min-width: ".concat(lg, "px) and (max-width: ").concat(xl - 1, "px)"),
    xl: "(min-width: ".concat(xl, "px)")
  };
}; // Used to override the real breakpoints with the docsite version

exports.getQueryList = getQueryList;
var getDocSiteBreakpoints = function getDocSiteBreakpoints(sgBreakpoint) {
  return _objectSpread(_objectSpread({}, breakpointWatcher.breakpoints), baseBreakpoints.reduce(function (newBreakpoints, thisBreakpoint) {
    return _objectSpread(_defineProperty({}, thisBreakpoint, thisBreakpoint === sgBreakpoint), newBreakpoints);
  }, {}));
}; // Calls all callbacks

exports.getDocSiteBreakpoints = getDocSiteBreakpoints;
var callCallbacks = function callCallbacks() {
  return breakpointWatcher.callbacks.forEach(function (callback) {
    return callback(breakpointWatcher.breakpoints);
  });
}; // Debounces callbacks so they are not called twice at a breakpoint boundary

exports.callCallbacks = callCallbacks;
var debouncedCallBacks = (0, _debounce["default"])(callCallbacks); // Updates the breakpointWatcher when media listener is fired

exports.debouncedCallBacks = debouncedCallBacks;
var updateMatchedBreakpoints = function updateMatchedBreakpoints(e, breakpoint) {
  var _sortedBreakpoints$fi;
  var _window = window,
    sgBreakpoint = _window.sgBreakpoint;
  breakpointWatcher.breakpoints[breakpoint] = e.matches;
  if (sgBreakpoint) breakpointWatcher.breakpoints = getDocSiteBreakpoints(sgBreakpoint);
  var _breakpointWatcher$br = breakpointWatcher.breakpoints,
    md = _breakpointWatcher$br.md,
    lg = _breakpointWatcher$br.lg,
    xl = _breakpointWatcher$br.xl;
  var sm = !(md || lg || xl);
  breakpointWatcher.breakpoints = _objectSpread(_objectSpread({}, breakpointWatcher.breakpoints), {}, {
    sm: sm,
    mdAndBelow: sm || md,
    mdAndAbove: md || lg || xl,
    lgAndBelow: sm || md || lg,
    lgAndAbove: lg || xl
  });
  breakpointWatcher.breakpoints.current = (_sortedBreakpoints$fi = sortedBreakpoints.find(function (thisBreakpoint) {
    return breakpointWatcher.breakpoints[thisBreakpoint];
  })) !== null && _sortedBreakpoints$fi !== void 0 ? _sortedBreakpoints$fi : 'sm';
  debouncedCallBacks();
}; // Set up the match media queries (only happens once)

exports.updateMatchedBreakpoints = updateMatchedBreakpoints;
var setUpQueries = function setUpQueries(themeBreakpoints) {
  var queryList = getQueryList(themeBreakpoints);
  baseBreakpoints.forEach(function (breakpoint) {
    var handleListener = function handleListener(e) {
      return updateMatchedBreakpoints(e, breakpoint);
    };
    breakpointWatcher.queries[breakpoint] = window.matchMedia(queryList[breakpoint]);
    breakpointWatcher.queries[breakpoint].addListener(handleListener);
    handleListener(breakpointWatcher.queries[breakpoint]);
  });
}; // Add a callback to the queue

exports.setUpQueries = setUpQueries;
var addBreakpointCallback = function addBreakpointCallback(callback, themeBreakpoints) {
  if (!breakpointWatcher.queries.sm) setUpQueries(themeBreakpoints);
  breakpointWatcher.callbacks.push(callback);
  debouncedCallBacks();
}; // Remove a callback from the queue

exports.addBreakpointCallback = addBreakpointCallback;
var removeBreakpointCallback = function removeBreakpointCallback(oldCallback) {
  breakpointWatcher.callbacks = breakpointWatcher.callbacks.filter(function (callback) {
    return callback !== oldCallback;
  });
};
exports.removeBreakpointCallback = removeBreakpointCallback;